import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { heroMockup, productName } from '../data/content';
import { SunRays } from './decor/SunRays';
import { LeafSprig } from './decor/LeafSprig';
export function HeroVisual() {
  const reduce = useReducedMotion();
  return <motion.div initial={reduce ? false : {
    opacity: 0,
    y: 14,
    scale: 0.98
  }} animate={{
    opacity: 1,
    y: 0,
    scale: 1
  }} transition={{
    duration: 0.3,
    ease: [0.23, 1, 0.32, 1]
  }} className="relative mx-auto w-full max-w-[720px]" data-id="element-177" data-mp="1g2fy2ipjh2r8">
      <SunRays className="pointer-events-none absolute left-1/2 top-1/2 z-0 w-[150%] max-w-none -translate-x-1/2 -translate-y-1/2 text-gold/30" data-id="element-178" data-mp="16b1spuawp8q6" />
      <LeafSprig className="pointer-events-none absolute -left-6 bottom-4 z-0 hidden h-32 w-16 -rotate-[20deg] text-leaf/50 sm:block" data-id="element-179" data-mp="wegk6yzohfhl" />
      <LeafSprig className="pointer-events-none absolute -right-6 top-6 z-0 hidden h-28 w-14 rotate-[20deg] text-leaf/50 sm:block" data-id="element-180" data-mp="sba9nf5j925b" />
      <div className="relative z-10" data-id="element-181" data-mp="nfledo0jq7et">
        <img src={heroMockup} alt={`${productName} — printable Gospel tracts and evangelism cards`} className="h-auto w-full" data-id="element-182" data-mp="2whjbcztip4dz" />
      </div>
    </motion.div>;
}